<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Vendor Master</mat-card-title>
    <button mat-fab [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent':'mat-mini-fab mat-button-disabled'"
      (click)="openDialog()" color="accent" style="position:absolute; right:20px;top:8px;width:35px; height:35px;"
         [disabled]="!isAdminGroupUser">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">add</i>
      </span>
    </button>
    <button mat-fab (click)="downloadAllRecords()" color="accent"
      style="position:absolute; right:60px;top:8px;width:35px; height:35px;"
      *ngIf="vendors != null && vendors.length >0" matTooltip="Download Records">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">download</i>
      </span>
    </button>
    <mat-card-subtitle></mat-card-subtitle>
    <div class="row">
      <div class="col-md-9">
      </div>
      <div class="col-md-3">
         <app-filter-input *ngIf="vendors!=null && vendors.length >0" (filterChanged)="applyFilter($event)"></app-filter-input>
      </div>
    </div>
    <mat-card-content>
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
          (matSortChange)="announceSortChange($event)" *ngIf="vendors != null && vendors.length >0" 
          aria-label="Table listing vendors">
          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef>S No. </th>
            <td mat-cell *matCellDef="let element; let i = index;"> 
              {{ (i + 1) + ((pageEvent?.pageSize || paginator.pageSize) * (pageEvent?.pageIndex || paginator.pageIndex)) }}
            </td>
          </ng-container>

          <!-- vendorCode Columnn -->
          <ng-container matColumnDef="vendorCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by vendorCode">Vendor Code
            </th>
            <td mat-cell *matCellDef="let element"> {{element.vendorCode}} </td>
          </ng-container>

          <!-- VendorName Column  -->
          <ng-container matColumnDef="vendorName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by VendorName">Vendor Name
            </th>
            <td mat-cell *matCellDef="let element"> {{element.vendorName}} </td>
          </ng-container>

          <!-- address Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by description">
              Description
            </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
          </ng-container>

          <!-- cityId Columnn -->
          <ng-container matColumnDef="cityId">
            <th mat-header-cell *matHeaderCellDef>cityId </th>
            <td mat-cell *matCellDef="let element"> {{element.cityId}} </td>
          </ng-container>
          <!-- stateName Column -->
          <ng-container matColumnDef="CityName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by CityName"> CityName
            </th>
            <td mat-cell *matCellDef="let element"> {{element.CityName}} </td>
          </ng-container>
          <!-- address Column -->
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by address"> Address </th>
            <td mat-cell *matCellDef="let element"> {{element.address}} </td>
          </ng-container>


          <!-- pinCode Column -->
          <ng-container matColumnDef="emailIds">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by emailIds"> Emails
            </th>
            <td mat-cell *matCellDef="let element"> {{element.emailIds}} </td>
          </ng-container>

          <!-- description Column -->
          <ng-container matColumnDef="contactNumbers">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by contactNumbers">
              Contact Nums </th>
            <td mat-cell *matCellDef="let element"> {{element.contactNumbers}} </td>
          </ng-container>

          <!-- isActive Column -->
          <ng-container matColumnDef="isActive">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by isActive"> Active </th>
            <td mat-cell *matCellDef="let element"> {{element.isActive}} </td>
          </ng-container>


          <!-- isDeleted Column -->
          <ng-container matColumnDef="isDeleted">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by isDeleted"> Deleted
            </th>
            <td mat-cell *matCellDef="let element"> {{element.isDeleted}} </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef> Edit </th>
              <td mat-cell *matCellDef="let element">
                <button mat-mini-fab aria-label="Edit" [disabled]="!isAdminGroupUser"
                  (click)="updateVendor($event, element)" class="action-button">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
          </ng-container>
           <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef> Delete </th>
              <td mat-cell *matCellDef="let element">
             <button mat-mini-fab aria-label="Delete" [disabled]="!isAdminGroupUser"
                  (click)="softDelete($event, element)" color="warn" class="action-button">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
           </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        
      <div *ngIf="isLoaderResult" class="custSpinner">
      </div>
      </div>
       <mat-paginator
      [length]="totalRows"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event; pageChanged($event)">
    </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>